module.exports = __webpack_public_path__ + "static/media/Profile.1871862d.png";